export default __webpack_public_path__ + "static/media/webdesign.ee3d733c.png";